/* ==========================================================================
   EXAM CATALOG — TakeMyOnlineClass.store
   Metadata for every practice track. Consumed by exam-engine.js.

   To add a track: append an object here. The hub page and the runner pick
   it up automatically — no other file needs to change.

   Fields
     id        slug used in URLs (?exam=ati-teas)
     name      display name
     icon      emoji shown on the hub card
     group     professional | quizprep | course
     blurb     one-line description on the card
     sections  content domains; `weight` mirrors the real blueprint
     minutes   default timed-mode length for a full-length sitting
     fullLen   number of items on the real exam (for "real exam mode")
     pass      passing threshold as a percentage, where one is published
     science   true = explanations may include diagrams
   ========================================================================== */

window.XP_CATALOG = [
  /* ---------------- Nursing & allied health ---------------- */
  {
    id: 'ati-teas', name: 'ATI TEAS 7', icon: '🩺', group: 'professional', science: true,
    blurb: 'Reading, Math, Science and English & Language Usage — full TEAS 7 blueprint.',
    minutes: 209, fullLen: 170, pass: 65,
    sections: [
      { id: 'reading', name: 'Reading', weight: 39 },
      { id: 'math', name: 'Mathematics', weight: 34 },
      { id: 'science', name: 'Science', weight: 44 },
      { id: 'english', name: 'English & Language Usage', weight: 33 }
    ]
  },
  {
    id: 'hesi', name: 'HESI A2', icon: '🏥', group: 'professional', science: true,
    blurb: 'Anatomy & Physiology, Biology, Chemistry, Math, Reading and Vocabulary.',
    minutes: 240, fullLen: 160, pass: 75,
    sections: [
      { id: 'anatomy', name: 'Anatomy & Physiology', weight: 25 },
      { id: 'biology', name: 'Biology', weight: 25 },
      { id: 'chemistry', name: 'Chemistry', weight: 25 },
      { id: 'math', name: 'Mathematics', weight: 25 },
      { id: 'reading', name: 'Reading Comprehension', weight: 25 },
      { id: 'vocab', name: 'Vocabulary & General Knowledge', weight: 25 }
    ]
  },
  {
    id: 'nclex-rn', name: 'NCLEX-RN', icon: '⚕️', group: 'professional', science: true,
    aliases: ['nclex'],
    blurb: 'Registered nurse licensure. Client Needs categories with clinical-judgement item stems.',
    minutes: 300, fullLen: 145, pass: 75,
    sections: [
      { id: 'safe-care', name: 'Management of Care & Safety', weight: 30 },
      { id: 'health-promo', name: 'Health Promotion & Maintenance', weight: 9 },
      { id: 'psychosocial', name: 'Psychosocial Integrity', weight: 9 },
      { id: 'physiological', name: 'Physiological Integrity', weight: 52 }
    ]
  },
  {
    /* The PN blueprint differs from the RN one in a way that matters for
       practice: PN weights Coordinated Care rather than Management of Care,
       and the scope-of-practice questions turn on what an LPN/LVN may do —
       delegation questions in particular run the opposite way. */
    id: 'nclex-pn', name: 'NCLEX-PN', icon: '⚕️', group: 'professional', science: true,
    blurb: 'Practical/vocational nurse licensure. Coordinated Care emphasis and LPN scope of practice.',
    minutes: 300, fullLen: 145, pass: 75,
    sections: [
      { id: 'coordinated-care', name: 'Coordinated Care', weight: 20 },
      { id: 'safety-infection', name: 'Safety & Infection Control', weight: 12 },
      { id: 'health-promo', name: 'Health Promotion & Maintenance', weight: 9 },
      { id: 'psychosocial', name: 'Psychosocial Integrity', weight: 11 },
      { id: 'physiological', name: 'Physiological Integrity', weight: 48 }
    ]
  },
  {
    id: 'dosage-calculation', name: 'Dosage Calculation', icon: '💉', group: 'professional', science: true,
    blurb: 'Oral, parenteral, IV flow rate, weight-based and reconstitution maths.',
    minutes: 60, fullLen: 50, pass: 90,
    sections: [
      { id: 'oral', name: 'Oral Dosage', weight: 25 },
      { id: 'parenteral', name: 'Parenteral Dosage', weight: 25 },
      { id: 'iv', name: 'IV Flow Rates', weight: 30 },
      { id: 'weight', name: 'Weight-Based & Paediatric', weight: 20 }
    ]
  },
  {
    id: 'fnp', name: 'FNP Certification', icon: '🩻', group: 'professional', science: true,
    blurb: 'Family nurse practitioner assessment, diagnosis and management across the lifespan.',
    minutes: 180, fullLen: 150, pass: 70,
    sections: [
      { id: 'assessment', name: 'Assessment', weight: 30 },
      { id: 'diagnosis', name: 'Diagnosis', weight: 25 },
      { id: 'plan', name: 'Clinical Management', weight: 30 },
      { id: 'professional', name: 'Professional Role', weight: 15 }
    ]
  },
  {
    id: 'nremt', name: 'NREMT', icon: '🚑', group: 'professional', science: true,
    blurb: 'Airway, cardiology, trauma, medical emergencies and EMS operations.',
    minutes: 120, fullLen: 120, pass: 70,
    sections: [
      { id: 'airway', name: 'Airway, Respiration & Ventilation', weight: 20 },
      { id: 'cardiology', name: 'Cardiology & Resuscitation', weight: 20 },
      { id: 'trauma', name: 'Trauma', weight: 15 },
      { id: 'medical', name: 'Medical & Obstetrics', weight: 30 },
      { id: 'ops', name: 'EMS Operations', weight: 15 }
    ]
  },
  {
    id: 'medical-assistant', name: 'Medical Assistant (CMA)', icon: '🩹', group: 'quizprep', science: true,
    blurb: 'Clinical procedures, pharmacology, administration and medical law.',
    minutes: 160, fullLen: 200, pass: 70,
    sections: [
      { id: 'clinical', name: 'Clinical Competency', weight: 40 },
      { id: 'admin', name: 'Administrative', weight: 25 },
      { id: 'general', name: 'General & Terminology', weight: 20 },
      { id: 'law', name: 'Law & Ethics', weight: 15 }
    ]
  },
  {
    id: 'phlebotomy', name: 'Phlebotomy (CPT)', icon: '🧪', group: 'quizprep', science: true,
    blurb: 'Order of draw, specimen handling, safety and patient preparation.',
    minutes: 120, fullLen: 120, pass: 70,
    sections: [
      { id: 'collection', name: 'Blood Collection', weight: 40 },
      { id: 'handling', name: 'Specimen Handling', weight: 25 },
      { id: 'safety', name: 'Safety & Infection Control', weight: 20 },
      { id: 'anatomy', name: 'Anatomy & Terminology', weight: 15 }
    ]
  },
  {
    id: 'knat', name: 'KNAT (Kaplan Nursing)', icon: '📗', group: 'quizprep', science: true,
    blurb: 'Kaplan Nursing Admissions Test — reading, math, writing and science.',
    minutes: 165, fullLen: 91, pass: 65,
    sections: [
      { id: 'reading', name: 'Reading', weight: 22 },
      { id: 'math', name: 'Mathematics', weight: 28 },
      { id: 'writing', name: 'Writing', weight: 21 },
      { id: 'science', name: 'Science', weight: 20 }
    ]
  },
  {
    id: 'nln-nex', name: 'NLN NEX / PAX', icon: '📘', group: 'quizprep', science: true,
    blurb: 'Verbal ability, mathematics and science for nursing admission.',
    minutes: 165, fullLen: 160, pass: 60,
    sections: [
      { id: 'verbal', name: 'Verbal Ability', weight: 33 },
      { id: 'math', name: 'Mathematics', weight: 33 },
      { id: 'science', name: 'Science', weight: 34 }
    ]
  },

  /* ---------------- ATI specialty content exams ---------------- */
  {
    id: 'ati-pharmacology', name: 'ATI Pharmacology', icon: '💊', group: 'professional', science: true,
    blurb: 'Drug classes, mechanisms, adverse effects and nursing considerations.',
    minutes: 90, fullLen: 60, pass: 70,
    sections: [
      { id: 'cardio', name: 'Cardiovascular Agents', weight: 25 },
      { id: 'neuro', name: 'Neurological & Psychiatric', weight: 20 },
      { id: 'anti', name: 'Anti-infectives', weight: 20 },
      { id: 'endocrine', name: 'Endocrine & Metabolic', weight: 20 },
      { id: 'safety', name: 'Medication Safety', weight: 15 }
    ]
  },
  {
    id: 'ati-med-surg-rn', name: 'ATI Med-Surg — RN', icon: '🛏️', group: 'professional', science: true,
    aliases: ['ati-med-surg'],
    blurb: 'Adult medical-surgical nursing for RN programmes. Full assessment, care planning and evaluation scope.',
    minutes: 90, fullLen: 70, pass: 70,
    sections: [
      { id: 'cardio', name: 'Cardiovascular', weight: 22 },
      { id: 'resp', name: 'Respiratory', weight: 18 },
      { id: 'gi', name: 'Gastrointestinal', weight: 15 },
      { id: 'renal', name: 'Renal & Endocrine', weight: 20 },
      { id: 'neuro', name: 'Neurological & Musculoskeletal', weight: 25 }
    ]
  },
  {
    id: 'ati-med-surg-pn', name: 'ATI Med-Surg — PN', icon: '🛏️', group: 'professional', science: true,
    blurb: 'Adult medical-surgical nursing for PN/LVN programmes. Data collection, reinforcing teaching and scope limits.',
    minutes: 90, fullLen: 70, pass: 70,
    sections: [
      { id: 'cardio', name: 'Cardiovascular', weight: 22 },
      { id: 'resp', name: 'Respiratory', weight: 18 },
      { id: 'gi', name: 'Gastrointestinal', weight: 15 },
      { id: 'renal', name: 'Renal & Endocrine', weight: 20 },
      { id: 'scope', name: 'Scope of Practice & Data Collection', weight: 25 }
    ]
  },
  {
    id: 'ati-anatomy', name: 'ATI Anatomy & Physiology', icon: '🫀', group: 'professional', science: true,
    blurb: 'Structure and function of all eleven organ systems.',
    minutes: 90, fullLen: 60, pass: 70,
    sections: [
      { id: 'cells', name: 'Cells & Tissues', weight: 15 },
      { id: 'cardio-resp', name: 'Cardiovascular & Respiratory', weight: 25 },
      { id: 'neuro', name: 'Nervous & Endocrine', weight: 25 },
      { id: 'musculo', name: 'Skeletal & Muscular', weight: 20 },
      { id: 'other', name: 'Digestive, Renal & Reproductive', weight: 15 }
    ]
  },
  {
    id: 'ati-fundamentals', name: 'ATI Nursing Fundamentals', icon: '🧭', group: 'professional', science: true,
    blurb: 'Core nursing process, safety, hygiene, mobility and documentation.',
    minutes: 90, fullLen: 60, pass: 70,
    sections: [
      { id: 'process', name: 'Nursing Process', weight: 25 },
      { id: 'safety', name: 'Safety & Infection Control', weight: 25 },
      { id: 'basic', name: 'Basic Care & Comfort', weight: 25 },
      { id: 'comm', name: 'Communication & Documentation', weight: 25 }
    ]
  },
  {
    id: 'ati-maternal', name: 'ATI Maternal-Newborn', icon: '👶', group: 'professional', science: true,
    blurb: 'Antepartum, intrapartum, postpartum and newborn nursing care.',
    minutes: 90, fullLen: 60, pass: 70,
    sections: [
      { id: 'ante', name: 'Antepartum', weight: 30 },
      { id: 'intra', name: 'Intrapartum', weight: 25 },
      { id: 'post', name: 'Postpartum', weight: 20 },
      { id: 'newborn', name: 'Newborn Care', weight: 25 }
    ]
  },
  {
    id: 'ati-pediatric', name: 'ATI Pediatric Nursing', icon: '🧸', group: 'professional', science: true,
    blurb: 'Growth, development and paediatric disease management.',
    minutes: 90, fullLen: 60, pass: 70,
    sections: [
      { id: 'growth', name: 'Growth & Development', weight: 25 },
      { id: 'resp', name: 'Respiratory & Cardiac', weight: 25 },
      { id: 'chronic', name: 'Chronic Conditions', weight: 25 },
      { id: 'safety', name: 'Safety & Medication', weight: 25 }
    ]
  },
  {
    id: 'ati-mental-health', name: 'ATI Mental Health', icon: '🧠', group: 'professional', science: true,
    blurb: 'Therapeutic communication, psychiatric disorders and psychopharmacology.',
    minutes: 90, fullLen: 60, pass: 70,
    sections: [
      { id: 'therapeutic', name: 'Therapeutic Communication', weight: 25 },
      { id: 'disorders', name: 'Psychiatric Disorders', weight: 35 },
      { id: 'meds', name: 'Psychopharmacology', weight: 25 },
      { id: 'crisis', name: 'Crisis & Safety', weight: 15 }
    ]
  },
  {
    id: 'ati-community', name: 'ATI Community Health', icon: '🏘️', group: 'professional', science: false,
    blurb: 'Population health, epidemiology, disaster response and health policy.',
    minutes: 90, fullLen: 60, pass: 70,
    sections: [
      { id: 'epi', name: 'Epidemiology', weight: 30 },
      { id: 'prevention', name: 'Levels of Prevention', weight: 25 },
      { id: 'vulnerable', name: 'Vulnerable Populations', weight: 25 },
      { id: 'disaster', name: 'Disaster & Emergency Preparedness', weight: 20 }
    ]
  },
  {
    id: 'ati-leadership', name: 'ATI Nursing Leadership', icon: '🎖️', group: 'professional', science: false,
    blurb: 'Delegation, prioritisation, quality improvement and legal principles.',
    minutes: 90, fullLen: 60, pass: 70,
    sections: [
      { id: 'delegation', name: 'Delegation & Supervision', weight: 30 },
      { id: 'priority', name: 'Prioritisation', weight: 25 },
      { id: 'quality', name: 'Quality Improvement', weight: 20 },
      { id: 'legal', name: 'Legal & Ethical', weight: 25 }
    ]
  },
  {
    id: 'ati-nutrition', name: 'ATI Nursing Nutrition', icon: '🥗', group: 'professional', science: true,
    blurb: 'Macronutrients, therapeutic diets, enteral feeding and lifespan nutrition.',
    minutes: 90, fullLen: 60, pass: 70,
    sections: [
      { id: 'macro', name: 'Nutrients & Metabolism', weight: 30 },
      { id: 'diets', name: 'Therapeutic Diets', weight: 30 },
      { id: 'support', name: 'Enteral & Parenteral Support', weight: 20 },
      { id: 'lifespan', name: 'Lifespan Nutrition', weight: 20 }
    ]
  },

  /* ---------------- Academic admissions ---------------- */
  {
    id: 'ged', name: 'GED', icon: '🎓', group: 'professional', science: true,
    blurb: 'Mathematical Reasoning, RLA, Science and Social Studies.',
    minutes: 425, fullLen: 160, pass: 60,
    sections: [
      { id: 'math', name: 'Mathematical Reasoning', weight: 25 },
      { id: 'rla', name: 'Reasoning Through Language Arts', weight: 25 },
      { id: 'science', name: 'Science', weight: 25 },
      { id: 'social', name: 'Social Studies', weight: 25 }
    ]
  },
  {
    id: 'gre', name: 'GRE General', icon: '📐', group: 'professional', science: false,
    blurb: 'Verbal Reasoning, Quantitative Reasoning and Analytical Writing.',
    minutes: 118, fullLen: 54, pass: 60,
    sections: [
      { id: 'verbal', name: 'Verbal Reasoning', weight: 40 },
      { id: 'quant', name: 'Quantitative Reasoning', weight: 40 },
      { id: 'writing', name: 'Analytical Writing', weight: 20 }
    ]
  },
  {
    id: 'gmat', name: 'GMAT Focus', icon: '📊', group: 'professional', science: false,
    blurb: 'Quantitative, Verbal and Data Insights reasoning.',
    minutes: 135, fullLen: 64, pass: 60,
    sections: [
      { id: 'quant', name: 'Quantitative Reasoning', weight: 33 },
      { id: 'verbal', name: 'Verbal Reasoning', weight: 33 },
      { id: 'data', name: 'Data Insights', weight: 34 }
    ]
  },
  {
    id: 'lsat', name: 'LSAT', icon: '⚖️', group: 'professional', science: false,
    blurb: 'Logical Reasoning and Reading Comprehension.',
    minutes: 140, fullLen: 76, pass: 60,
    sections: [
      { id: 'logical', name: 'Logical Reasoning', weight: 50 },
      { id: 'reading', name: 'Reading Comprehension', weight: 50 }
    ]
  },
  {
    id: 'mcat', name: 'MCAT', icon: '🧬', group: 'professional', science: true,
    blurb: 'Biological, chemical, physical and psychosocial foundations.',
    minutes: 375, fullLen: 230, pass: 60,
    sections: [
      { id: 'chem-phys', name: 'Chemical & Physical Foundations', weight: 25 },
      { id: 'cars', name: 'Critical Analysis & Reasoning', weight: 25 },
      { id: 'bio-biochem', name: 'Biological & Biochemical Foundations', weight: 25 },
      { id: 'psych-soc', name: 'Psychological & Social Foundations', weight: 25 }
    ]
  },
  {
    id: 'toefl', name: 'TOEFL iBT', icon: '🌍', group: 'professional', science: false,
    blurb: 'Reading, Listening, Speaking and Writing in academic English.',
    minutes: 116, fullLen: 76, pass: 60,
    sections: [
      { id: 'reading', name: 'Reading', weight: 25 },
      { id: 'listening', name: 'Listening', weight: 25 },
      { id: 'speaking', name: 'Speaking', weight: 25 },
      { id: 'writing', name: 'Writing', weight: 25 }
    ]
  },
  {
    id: 'clep', name: 'CLEP', icon: '🏛️', group: 'professional', science: true,
    blurb: 'College-level subject examinations for credit by exam.',
    minutes: 90, fullLen: 100, pass: 50,
    sections: [
      { id: 'composition', name: 'College Composition', weight: 25 },
      { id: 'math', name: 'College Mathematics', weight: 25 },
      { id: 'science', name: 'Natural Sciences', weight: 25 },
      { id: 'social', name: 'Social Sciences & History', weight: 25 }
    ]
  },
  {
    id: 'tsi', name: 'TSIA2', icon: '📏', group: 'professional', science: false,
    blurb: 'Texas Success Initiative — mathematics and English language arts.',
    minutes: 120, fullLen: 60, pass: 60,
    sections: [
      { id: 'math', name: 'Mathematics', weight: 50 },
      { id: 'elar', name: 'English Language Arts & Reading', weight: 50 }
    ]
  },
  {
    id: 'math-placement', name: 'Math Placement', icon: '➗', group: 'quizprep', science: false,
    blurb: 'Arithmetic through pre-calculus placement diagnostics.',
    minutes: 90, fullLen: 50, pass: 60,
    sections: [
      { id: 'arithmetic', name: 'Arithmetic & Pre-Algebra', weight: 25 },
      { id: 'algebra', name: 'Elementary Algebra', weight: 30 },
      { id: 'intermediate', name: 'Intermediate Algebra', weight: 25 },
      { id: 'precalc', name: 'Trigonometry & Pre-Calculus', weight: 20 }
    ]
  },
  {
    id: 'aleks', name: 'ALEKS', icon: '🔢', group: 'quizprep', science: true,
    blurb: 'Adaptive placement across arithmetic, algebra, chemistry and statistics.',
    minutes: 120, fullLen: 30, pass: 60,
    sections: [
      { id: 'arithmetic', name: 'Whole Numbers & Fractions', weight: 25 },
      { id: 'algebra', name: 'Algebraic Expressions & Equations', weight: 30 },
      { id: 'functions', name: 'Functions & Graphs', weight: 25 },
      { id: 'stats', name: 'Data, Probability & Statistics', weight: 20 }
    ]
  },

  /* ---------------- Aptitude, professional certification ---------------- */
  {
    id: 'asvab', name: 'ASVAB / AFQT', icon: '🎖️', group: 'professional', science: true,
    blurb: 'Arithmetic Reasoning, Word Knowledge, Paragraph Comprehension and Math Knowledge.',
    minutes: 154, fullLen: 145, pass: 50,
    sections: [
      { id: 'ar', name: 'Arithmetic Reasoning', weight: 25 },
      { id: 'mk', name: 'Mathematics Knowledge', weight: 25 },
      { id: 'wk', name: 'Word Knowledge', weight: 25 },
      { id: 'pc', name: 'Paragraph Comprehension', weight: 15 },
      { id: 'gs', name: 'General Science', weight: 10 }
    ]
  },
  {
    id: 'ccat', name: 'CCAT (Criteria)', icon: '⏱️', group: 'quizprep', science: false,
    blurb: 'Fast-paced verbal, math/logic and spatial reasoning — 50 items in 15 minutes.',
    minutes: 15, fullLen: 50, pass: 50,
    sections: [
      { id: 'verbal', name: 'Verbal Reasoning', weight: 33 },
      { id: 'math', name: 'Math & Logic', weight: 34 },
      { id: 'spatial', name: 'Spatial Reasoning', weight: 33 }
    ]
  },
  {
    id: 'wonderlic', name: 'Wonderlic', icon: '⚡', group: 'professional', science: false,
    blurb: 'Cognitive ability screening — 50 items in 12 minutes.',
    minutes: 12, fullLen: 50, pass: 50,
    sections: [
      { id: 'verbal', name: 'Verbal', weight: 35 },
      { id: 'math', name: 'Quantitative', weight: 40 },
      { id: 'logic', name: 'Logic & Spatial', weight: 25 }
    ]
  },
  {
    id: 'pmp', name: 'PMP', icon: '📋', group: 'professional', science: false,
    blurb: 'People, Process and Business Environment domains (PMBOK 7 / Agile).',
    minutes: 230, fullLen: 180, pass: 65,
    sections: [
      { id: 'people', name: 'People', weight: 42 },
      { id: 'process', name: 'Process', weight: 50 },
      { id: 'business', name: 'Business Environment', weight: 8 }
    ]
  },
  {
    id: 'comptia', name: 'CompTIA A+ / Security+', icon: '💻', group: 'professional', science: false,
    blurb: 'Hardware, networking, operating systems, security and troubleshooting.',
    minutes: 90, fullLen: 90, pass: 72,
    sections: [
      { id: 'hardware', name: 'Hardware', weight: 25 },
      { id: 'networking', name: 'Networking', weight: 20 },
      { id: 'os', name: 'Operating Systems', weight: 20 },
      { id: 'security', name: 'Security', weight: 25 },
      { id: 'troubleshoot', name: 'Troubleshooting', weight: 10 }
    ]
  },
  {
    id: 'real-estate', name: 'Real Estate Licensing', icon: '🏠', group: 'professional', science: false,
    blurb: 'National portion — property ownership, contracts, finance and agency law.',
    minutes: 180, fullLen: 120, pass: 70,
    sections: [
      { id: 'ownership', name: 'Property Ownership & Land Use', weight: 20 },
      { id: 'agency', name: 'Agency & Fiduciary Duty', weight: 20 },
      { id: 'contracts', name: 'Contracts', weight: 25 },
      { id: 'finance', name: 'Financing & Valuation', weight: 25 },
      { id: 'law', name: 'Fair Housing & Practice Law', weight: 10 }
    ]
  },
  {
    id: 'nce', name: 'NCE (Counseling)', icon: '🗣️', group: 'quizprep', science: false,
    blurb: 'National Counselor Examination — eight CACREP core areas.',
    minutes: 225, fullLen: 200, pass: 60,
    sections: [
      { id: 'human-growth', name: 'Human Growth & Development', weight: 15 },
      { id: 'helping', name: 'Counseling & Helping Relationships', weight: 25 },
      { id: 'group', name: 'Group Counseling', weight: 15 },
      { id: 'assessment', name: 'Assessment & Testing', weight: 20 },
      { id: 'ethics', name: 'Professional Orientation & Ethics', weight: 25 }
    ]
  },
  {
    id: 'wgu', name: 'WGU Objective Assessments', icon: '🦉', group: 'professional', science: true,
    blurb: 'Competency-based OA prep across WGU\u2019s most-failed courses.',
    minutes: 120, fullLen: 70, pass: 68,
    sections: [
      { id: 'it', name: 'IT & Networking', weight: 25 },
      { id: 'business', name: 'Business & Management', weight: 25 },
      { id: 'health', name: 'Health & Nursing', weight: 25 },
      { id: 'gened', name: 'General Education', weight: 25 }
    ]
  }
];

/* Difficulty ladder — shared everywhere */
window.XP_DIFFICULTIES = [
  { id: 'easy',     name: 'Easy',     hint: 'Recall and single-step application' },
  { id: 'moderate', name: 'Moderate', hint: 'Multi-step reasoning, typical exam level' },
  { id: 'hard',     name: 'Hard',     hint: 'Layered reasoning and distractor-heavy stems' },
  { id: 'advanced', name: 'Advanced', hint: 'Synthesis, edge cases and applied clinical judgement' },
  { id: 'combined', name: 'Combined', hint: 'Mixed spread, matching the real exam' }
];

/* Free / premium boundary */
window.XP_LIMITS = {
  freeMax: 400,          // items per course, per sitting, at no cost
  premiumMax: 2000,      // hard ceiling with approval
  premiumPrice: 12,      // USD
  premiumHandle: 'exam-practice-premium-unlock' // Shopify product handle
};
